import { getConfig } from './config'

export default ({ $config, $integrationsManager }) => {
    const config = getConfig($config.platform.mode)

    $integrationsManager.loaders.onNuxtReadyLoader(() => {
        const script = document.createElement('script')
        script.id = 'bolt-track'
        script.async = true
        script.src = `${config.cdn}/track.js`
        script.setAttribute('data-publishable-key', $config.runtime.integrations.bolt.publicKey)
        document.head.appendChild(script)
    }, 20000)

    return new $integrationsManager.loaders.OnDemandLoader([
        {
            src: `${config.cdn}/connect.js`,
            id: 'bolt-connect',
            'data-publishable-key': $config.runtime.integrations.bolt.publicKey,
        },
    ])
}
